import { Navigate } from 'react-router-dom';
import { useAuthStore, type UserRole } from '../stores/auth.store';

/**
 * Role-based route guard — sayfa için role allow-list gerektirir.
 *
 * abilities.rules.json'da subject olarak modellenmemiş ama role-restricted
 * olan sayfalar için kullanılır (e-Faturalar, Muhasebe, Pilot Sağlığı).
 * Backend AbilitiesGuard zaten 403 atıyor; bu wrapper "kırık UI + console
 * 403 spam" yerine net redirect sağlar.
 *
 * Kullanım:
 *   <Route path="/e-faturalar" element={
 *     <RequireRole roles={['OWNER', 'DEPARTMENT_MANAGER']}>
 *       <EInvoicesPage />
 *     </RequireRole>
 *   } />
 */
export function RequireRole({
  roles,
  exclude,
  redirectTo = '/',
  children,
}: {
  /** İzin verilen roller (allow-list). Verilirse rol bu listede olmalı. */
  roles?: UserRole[];
  /** Hariç tutulan roller (deny-list). Verilirse rol bu listede OLMAMALI (ör. SELF_ONLY_ROLES). */
  exclude?: UserRole[];
  redirectTo?: string;
  children: React.ReactNode;
}) {
  const role = useAuthStore((s) => s.user?.role ?? null);
  if (!role) return <Navigate to={redirectTo} replace />;
  if (roles && !roles.includes(role)) return <Navigate to={redirectTo} replace />;
  if (exclude && exclude.includes(role)) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
